@if (openInquiries$().length > 0) {
  <button
    (click)="joinRunningAppointment()"
    aria-label="Join running appointment"
    i18n-aria-label
    class="join-appointment-button"
    mat-button
    [disabled]="refreshing$()"
  >
    <mat-icon class="join-appointment-button-icon"
      >radio_button_checked
    </mat-icon>
    @if (openInquiries$().length > 1) {
      <span class="join-appointment-button-title" i18n
        >Mehrere laufende Termine ansehen</span
      >
    } @else {
      <span class="join-appointment-button-title" i18n
        >Laufenden Termin beitreten</span
      >
    }
  </button>
}
